import { render, staticRenderFns } from "./experienceProduct.vue?vue&type=template&id=6f07ec54&scoped=true&"
import script from "./experienceProduct.vue?vue&type=script&lang=js&"
export * from "./experienceProduct.vue?vue&type=script&lang=js&"
import style0 from "./experienceProduct.vue?vue&type=style&index=0&id=6f07ec54&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f07ec54",
  null
  
)

export default component.exports